/** Giai đoạn vòng đời của tổ chức hiện tại — cache dùng cho hàm đồng bộ (stageLabel…). Do useLifecycleStages nạp. */
import { i18n } from '@/lib/i18n'

/** start = khách mới · nurture = đang chăm · won = đã mua (báo cáo đếm chuyển đổi) · lost = rời bỏ */
export type StageKind = 'start' | 'nurture' | 'won' | 'lost'

export const STAGE_KIND_LABELS: Record<StageKind, string> = {
  get start() { return i18n.t('sharedMisc:lifecycleStages.kind.start') },
  get nurture() { return i18n.t('sharedMisc:lifecycleStages.kind.nurture') },
  get won() { return i18n.t('sharedMisc:lifecycleStages.kind.won') },
  get lost() { return i18n.t('sharedMisc:lifecycleStages.kind.lost') },
}

/** Trường bổ sung khi đưa khách vào bước. `ref`: trường khách hệ thống (xem lib/stage-fields.ts) hoặc `prop:<fieldKey>` (thuộc tính khách hàng). */
export interface StageField {
  ref: string
  required: boolean
}

export interface StageDef {
  key: string
  label: string
  color: string | null
  kind: StageKind
  sortOrder: number
  fields: StageField[]
}

/** Bộ mặc định (khớp backend) — dùng khi chưa nạp xong hoặc tổ chức chưa tự cấu hình. */
const DEFAULT_STAGE_SEEDS = [
  { key: 'subscriber', labelKey: 'subscriber', color: '#64748b', kind: 'start' as StageKind },
  { key: 'lead', labelKey: 'lead', color: '#3b82f6', kind: 'nurture' as StageKind },
  { key: 'qualified', labelKey: 'qualified', color: '#06b6d4', kind: 'nurture' as StageKind },
  { key: 'opportunity', labelKey: 'opportunity', color: '#f59e0b', kind: 'nurture' as StageKind },
  { key: 'customer', labelKey: 'customer', color: '#10b981', kind: 'won' as StageKind },
  { key: 'evangelist', labelKey: 'evangelist', color: '#8b5cf6', kind: 'won' as StageKind },
  { key: 'churned', labelKey: 'churned', color: '#ef4444', kind: 'lost' as StageKind },
] as const

/** Bộ mặc định (khớp backend) — dùng khi chưa nạp xong hoặc tổ chức chưa tự cấu hình. `label` là getter (đổi theo ngôn ngữ). */
export function defaultStages(): StageDef[] {
  return DEFAULT_STAGE_SEEDS.map((s, i) => ({
    key: s.key,
    color: s.color,
    kind: s.kind,
    sortOrder: i,
    fields: [] as StageField[],
    get label() { return i18n.t(`sharedMisc:lifecycleStages.defaultLabels.${s.labelKey}`) },
  }))
}


/** Không xoá / không dời được: bước ĐẦU, nơi khách mới vào (khớp backend PROTECTED_STAGE_KEYS). Mọi bước khác tự do. */
export const PROTECTED_STAGE_KEYS = ['subscriber']

let current: StageDef[] = defaultStages()

export function getStages(): StageDef[] {
  return current
}
export function setStages(stages: StageDef[]): void {
  if (stages.length) current = stages
}
